import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useServer } from '../contexts/ServerContext';

function Home() {
  const { serverUrl, setServerUrl, isDebugMode, setIsDebugMode } = useServer();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const handleServerUrlChange = (e) => {
    setServerUrl(e.target.value);
  };

  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold text-center mb-12">二维码共享系统</h1>
      
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <Link
            to="/publish"
            className="block p-6 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors text-center"
          >
            <h2 className="text-2xl font-semibold mb-2">发布模式</h2>
            <p>扫描二维码并分享给远程订阅者</p>
          </Link>

          <Link
            to="/subscribe"
            className="block p-6 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors text-center"
          >
            <h2 className="text-2xl font-semibold mb-2">订阅模式</h2>
            <p>输入发布码查看远程二维码</p>
          </Link>

          <Link
            to="/local"
            className="block p-6 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors text-center"
          >
            <h2 className="text-2xl font-semibold mb-2">本地模式</h2>
            <p>扫描一次二维码后本地生成动态码</p>
          </Link>
        </div>

        {/* 设置下拉栏 */}
        <div>
          <button
            onClick={() => setIsSettingsOpen(!isSettingsOpen)}
            className="w-full flex items-center justify-between p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            <h2 className="text-xl font-semibold">高级设置</h2>
            <span className="transform transition-transform duration-200" style={{ transform: isSettingsOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              ▼
            </span>
          </button>
          
          {isSettingsOpen && (
            <div className="mt-2 p-4 bg-gray-100 rounded-lg space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  服务器地址
                </label>
                <input
                  type="text"
                  value={serverUrl}
                  onChange={handleServerUrlChange}
                  className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="https://api.fbl.9estu.com"
                />
                <p className="mt-2 text-sm text-gray-500">
                  当前服务器地址: {serverUrl}
                </p>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <div>
                  <h3 className="text-sm font-medium text-gray-700">调试模式</h3>
                  <p className="text-sm text-gray-500">启用后可查看详细的调试信息</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isDebugMode}
                    onChange={(e) => setIsDebugMode(e.target.checked)}
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Home; 